import React, {useContext, useState, useEffect} from 'react'
import "../styles/haiImmobile.scss"
import {Languages} from "./Home"
import img from "../assets/immagini/img_2.jpg"
import casa_it from "../assets/icone/casa_it.svg";
import immobiliare from "../assets/icone/immobiliare.svg";
import idealista from "../assets/icone/idealista.svg";

export default function HaiImmobile() {
    const lang = useContext(Languages)
    const posizionePartenza = -300
    const dimensioni = [1500, 1500, 1500, 1500, 1500, 1500 ,1500 ,1500, 1500, 1500, 1500, 1500, 1500, 1500 ,1500 ,1500, 1500]
    const idealWidth = 1920;
    const maxWidth = 330;
    const minWidth = 165;

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // Funzione per gestire il cambiamento delle dimensioni della finestra
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Effetto per aggiungere e rimuovere l'ascolto degli eventi di ridimensionamento
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Pulisci l'ascoltatore degli eventi al momento della disconnessione dell'effetto
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Calcola la proporzione in base alla larghezza attuale della finestra
    const proportion = screenWidth / idealWidth /2;
    return (
        <div className='hai_immobile_section_colore verde'>

            <div className='max-w'>
                <h3 className='titolo_sezione' data-aos="zoom-out-up" data-aos-duration="1000">{lang['cerchi casa?']}</h3>

                <p className='testo_generico' data-aos="zoom-out-up" data-aos-duration="1000">{lang["Probabilmente sì, altrimenti"]} <br />
                {lang["non saresti qui."]}</p>

                <p className='testo_generico' data-aos="zoom-out-up" data-aos-duration="1000">
                    {/*{lang["Se cerchi una casa da comprare"]}<br />
                    {lang["Per chi, come noi, è"]}*/}
                    Se cerchi una casa da comprare o prendere in affitto,
                    puoi trovare tutte le nostre proposte sui portali immobiliari.<br />
                    Per farti risparmiare tempo, eccoti i link.
                </p>

                <div className='cerchi_casa_loghi_container' >
                    <a href="https://www.immobiliare.it/agenzie-immobiliari/383482/studio-aurea-opera/" target="_blank" className='link_footer'>
                    <div className='elemento_logo_container' data-aos="fade-right" data-aos-duration="1000">
                        <div className='elemento_logo'><img src={immobiliare} className='logo_cerchi_casa'/></div>
                        <div className='elemento_scritta'>Immobiliare.it</div>
                    </div>
                    </a>

                    <a href="https://www.idealista.it/pro/studio-aurea/" target="_blank" className='link_footer'>
                    <div className='elemento_logo_container' data-aos="fade-right" data-aos-duration="1000" data-aos-delay="300">
                        <div className='elemento_logo'><img src={idealista} className='logo_cerchi_casa'/></div>
                        <div className='elemento_scritta'>Idealista</div>
                    </div>
                    </a>

                    <a href="https://www.casa.it/agenzie/studio-aurea-1210277/" target="_blank" className='link_footer'>
                    <div className='elemento_logo_container' data-aos="fade-right" data-aos-duration="1000" data-aos-delay="600">
                        <div className='elemento_logo'><img src={casa_it} className='logo_cerchi_casa'/></div>
                        <div className='elemento_scritta'>Casa.it</div>
                    </div>
                    </a>

                    
                </div>
            </div>
            
            <div className='hai_immobile_section max-w'>

                <span data-aos="flip-right" data-aos-duration="1000" id="img_2_home">
                <div className='hai_immobile_immagine_container'>
                    {/*<img src={img} className='hai_immobile_immagine'/>*/}
                    {dimensioni.map((elem, index) => {
            let width = 330 * proportion;
            let widthSubstract = 30 * proportion;
            widthSubstract = widthSubstract <= 30 ? widthSubstract : 30;
            widthSubstract = widthSubstract <= 15 ? 15 : widthSubstract;

            // Limita la larghezza massima a 330 e la larghezza minima a 180
            width = Math.min(Math.max(width, minWidth), maxWidth);

            // Calcola il ritardo per ciascuna colonna (ad esempio, 0.2s, 0.4s, 0.6s, ecc.)
            const delay = 0.2 * index + "s";

            // Applica la classe CSS e il ritardo
            const columnClassName = "column c" + index + " column-animation column_riquadro";
            const columnStyle = {
                left: posizionePartenza + width * index,
                height: elem,
                width: width - widthSubstract,
                animationDelay: delay, // Applica il ritardo all'animazione
            };
                return (
                    <div key={index} className={columnClassName} style={columnStyle}/>
                )
            })}
                </div>
                </span>

                <div className='hai_immobile_descrizione'>
                    <h3 className='titolo_sezione' data-aos="zoom-out-up" data-aos-duration="1000">{lang['HAI UN IMMOBILE CHE VUOI']}&nbsp;
                    {lang['VENDERE O AFFITTARE?']}
                    </h3>

                    <p className='testo_generico' data-aos="zoom-out-up" data-aos-duration="1000">
                        {/*lang["ottima idea"]*/}
                        Ottima idea! Anche noi, al tuo posto, <br />
                        ci saremmo rivolti a noi.
                    </p>

                    <p className='testo_generico' data-aos="zoom-out-up" data-aos-duration="1000">
                        {/*lang["Se anche tu sei uno di quelli"]*/}
                        Se quando stai male chiami il medico e non vai su internet a farti le diagnosi da solo, applica
                        lo stesso criterio con la casa.<br />
                        Non venderla da solo, affidati a noi che lo facciamo di lavoro.
                    </p>

                    <p className='testo_generico' data-aos="zoom-out-up" data-aos-duration="1000">
                        {lang["In questo caso avremmo bisogno di farci una chiacchierata."]}
                    </p>

                    <br /><br />

                    <p className='testo_generico' data-aos="zoom-out-up" data-aos-duration="1000">
                        <b>{lang["Compila il form"]}</b>
                    </p>
                </div>
            </div>
        </div>
  )
}
